// extracted by mini-css-extract-plugin
module.exports = {"normal_img":"EventImage_normal_img__ZKAVP","full_img":"EventImage_full_img__3KDFh","img_wrapper":"EventImage_img_wrapper__qpUVa"};